// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".small-loader{position:relative;min-width:100px;min-height:30px;display:flex;justify-content:center;align-items:center}.small-loader .loader{min-height:25px}.small-loader .loader>div{width:25px;height:25px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
